<template>
	<footer>
		<h3 v-if="casinoGroupName">{{ casinoGroupName }}</h3>
		<h3 v-else>&nbsp;</h3>
		<div class="versions" v-if="!isMobile">
			<span>Server Version: {{ serverVersion.serverVersion }}</span>
			<span>Operator Apps Version: {{ operatorAppsVersion }}</span>
		</div>
		<div v-if="devMode" class="dev-mode">Client running in development mode</div>
	</footer>
</template>

<script>
export default {
	name: "Footer",
	props: {
		serverVersion: Object,
		isMobile: Boolean,
	},
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
footer h3 {
	user-select: none;
}

footer {
	position: fixed;
	bottom: 0;
	width: 100%;
	background-color: #32373f;
}

.dev-mode {
	position: absolute;
	right: 15px;
	top: 22px;
	color: #f00;
	font-weight: bold;
}

.versions {
	display: flex;
	flex-flow: column nowrap;
	position: absolute;
	top: 5px;
	left: 0;
	margin: 5px 15px;
}

.versions span {
	user-select: all;
}
</style>
